import { semverCompare } from '@repo/utils/helpers/string';
import { requiredMinimumDesktopVersion } from '@app/config';

function desktopMeetsRequiredVersion(): boolean {
  return (
    semverCompare(window.desktopIntegrations.appInfo.version, requiredMinimumDesktopVersion) >= 0
  );
}

export function desktopRequiresUpdate(): boolean {
  if (!window.app.isElectron) {
    return false;
  }

  if (!window.desktopIntegrations || !window.desktopIntegrations.appInfo) {
    return true;
  }

  return !desktopMeetsRequiredVersion();
}
